import React from 'react';
import { View } from 'react-native';

// Mock component that just renders its children, satisfying the component usage
const ViewShot = React.forwardRef(({ children, ...props }, ref) => (
  <View ref={ref} {...props}>
    {children}
  </View>
));

export default ViewShot;

// Mock functions that are also exported by the library
export const captureScreen = () => Promise.resolve('');
export const captureRef = () => Promise.resolve('');